var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Entry',{ref:"entry",attrs:{"type":"login","height":700,"bridge_key":_vm.bridge_key}})
}
var staticRenderFns = []

export { render, staticRenderFns }